import { createFileRoute } from "@tanstack/react-router";
import PlantsHub, { plantGuidesQueryOptions } from "@/pages/PlantsHub";

const TITLE = "Plant Grow Guides A–Z | Garden-Review";
const DESCRIPTION =
  "UK plant grow guides A–Z: planting depths, pruning timings, care calendars and pest fixes for perennials, shrubs, climbers, bulbs and houseplants.";

export const Route = createFileRoute("/plants/")({
  loader: async ({ context }) => {
    try {
      return await context.queryClient.ensureQueryData(plantGuidesQueryOptions);
    } catch {
      return null;
    }
  },
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "en_GB" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://www.garden-review.co.uk/plants" }],
  }),
  component: PlantsRoute,
});

function PlantsRoute() {
  const guides = Route.useLoaderData();
  return <PlantsHub initialGuides={guides ?? null} />;
}
